import { ContentTypeEnumSchema, JsonContentTypeEnumSchema, MessageAttributesSchema } from '../schemas/sharedSchemas';
import { z } from 'zod';

export enum MessageType {
    MESSAGE = 'MESSAGE',
    EVENT = 'EVENT',
    MESSAGEMETADATA = 'MESSAGEMETADATA',
}

export enum MessageParticipantRole {
    AGENT = 'AGENT',
    CUSTOMER = 'CUSTOMER',
    SYSTEM = 'SYSTEM',
    CUSTOM_BOT = 'CUSTOM_BOT',
    SUPERVISOR = 'SUPERVISOR',
}

export enum MessageVisibility {
    AGENT = 'AGENT',
    CUSTOMER = 'CUSTOMER',
    ALL = 'ALL',
}

export enum WebSocketTopic {
    AWS_SHERLOCK = 'aws/sherlock'
}

export type JsonContentType = z.infer<typeof JsonContentTypeEnumSchema>;
export type ContentType = z.infer<typeof ContentTypeEnumSchema>;
export type MessageAttributesType = z.infer<typeof MessageAttributesSchema>;
